import { ScrollView, StyleSheet, View } from 'react-native';
import { Text } from '../../../components/primitives/Text';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { tokens } from '../../../theme/tokens';
import type { ColumnMapping } from '../types';

interface ImportPreviewTableProps {
  headers: string[];
  rows: string[][];
  mappings: ColumnMapping[];
}

export function ImportPreviewTable({ headers, rows, mappings }: Readonly<ImportPreviewTableProps>) {
  const { t } = useTranslation();
  const activeMappings = mappings.filter((m) => m.crmField !== 'skip');
  const columnIndices = activeMappings.map((m) => headers.indexOf(m.header));

  return (
    <ScrollView horizontal showsHorizontalScrollIndicator testID="import_preview_table">
      <View>
        <View style={styles.headerRow}>
          {activeMappings.map((mapping) => (
            <View key={mapping.header} style={styles.cell}>
              <Text variant="caption" color={colors.primary[500]} numberOfLines={1}>
                {t(`leadImport.crmFields.${mapping.crmField}`)}
              </Text>
            </View>
          ))}
        </View>

        {rows.map((row, rowIndex) => (
          <View
            key={`row-${rowIndex}`}
            style={[styles.dataRow, rowIndex % 2 === 0 && styles.dataRowEven]}
          >
            {columnIndices.map((colIndex, cellIndex) => (
              <View key={`cell-${rowIndex}-${cellIndex}`} style={styles.cell}>
                <Text variant="caption" color={colors.text.secondary} numberOfLines={1}>
                  {colIndex >= 0 ? (row[colIndex] ?? '') : ''}
                </Text>
              </View>
            ))}
          </View>
        ))}
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  headerRow: {
    flexDirection: 'row',
    backgroundColor: colors.background.tertiary,
    borderTopLeftRadius: tokens.radius.md,
    borderTopRightRadius: tokens.radius.md,
    borderBottomWidth: 1,
    borderBottomColor: colors.border.muted,
  },
  dataRow: {
    flexDirection: 'row',
  },
  dataRowEven: {
    backgroundColor: colors.background.secondary,
  },
  cell: {
    width: 140,
    paddingHorizontal: tokens.spacing.md,
    paddingVertical: tokens.spacing.sm,
  },
});
